import Vue from "vue";
import Router from "vue-router";
import loginService from "./services/LoginService";
Vue.use(Router);

const Home = () => import('./components/Home')
const Enquesta = () => import('./components/enquesta/Enquesta')
const Login = () => import("./components/Login")
const Fitxa = () => import("./components/fitxes/Fitxa")
//const Tableau = () => import('./components/tableau/PanelPhone')
const AdminEnquestes = () => import(/* webpackChunkName: "group-admin" */ './components/admin/AdminEnquestes')
const AdminResultats = () => import(/* webpackChunkName: "group-admin" */ './components/admin/Resultats')
const AdminDireccio = () => import(/* webpackChunkName: "group-admin" */ './components/admin/Direccio')
const AdminDireccioEnquesta = () => import(/* webpackChunkName: "group-admin" */ './components/admin/AdminDireccioEnquesta')
const AdminUsuaris = () => import(/* webpackChunkName: "group-admin" */ './components/admin/AdminUsuaris')
const AdminAuditAcces = () => import(/* webpackChunkName: "group-admin" */ './components/admin/AdminAuditAcces')


const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      alias: "/home",
      component: Home
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/admin/fitxa",
      name: "fitxa",
      component: Fitxa
    },
    {
      path: '/catsalut/e/:access_key',
      component: Enquesta
    },
    {
      path: '/catsalut/t/:access_key',
      component: AdminDireccioEnquesta
    },
    {
      path: "/admin/enquestes",
      component: AdminEnquestes
    },
    {
      path: "/admin/resultats",
      name: "resultats",
      component: AdminResultats
    },
    {
      path: "/admin/direccio",
      name: "direccio",
      component: AdminDireccio
    },
    {
      path: "/admin/direccioEnquesta",
      name: "direccioEnquesta",
      component: AdminDireccioEnquesta
    },
    {
      path: "/admin/usuaris",
      name: "usuaris",
      component: AdminUsuaris
    },
    {
      path: "/admin/audit",
      name: "audit",
      component: AdminAuditAcces
    }
  ]
});
router.beforeEach((to, from, next) => {
  //Si es demana una ruta que necessita login redirigir directament al login
  //next({ name: 'login' })
  if (!loginService.isLoggedIn() && to.fullPath && to.fullPath.includes("/admin/")) {next({ name: 'login' })}  
  else next()
  
});
export default router;